var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"bottomArea"},[_c('p',{staticClass:"companyName"}),_vm._m(0),_c('button',{staticClass:"goApp",on:{"click":_vm.goApp}},[_vm._v("前往APP")])]),_c('WxShare',{ref:"share"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appInfo"},[_c('p',{staticClass:"appName"},[_vm._v("启航教育APP")]),_c('p',{staticClass:"appDescription"},[_vm._v("免费下载课程视频，听课更流畅")])])
}]

export { render, staticRenderFns }